import { get, Just, Nothing } from 'pratica';
import _get from 'lodash/get';
import ApiService from '../../util/api';
import { fetchWeddingTheme } from '../../actions/WeddingActions';

export const ActionTypes = {
  REQUEST_SEARCH_CARD_SUITES:
    'zola/cards/card_catalog/REQUEST_SEARCH_CARD_SUITES',
  RECEIVE_SEARCH_CARD_SUITES:
    'zola/cards/card_catalog/RECEIVE_SEARCH_CARD_SUITES',
  RECEIVE_THEME_MATCHED_CARD_SUITES: // Card suites that are matched to the user based on the theme they selected for their wedding website
    'zola/cards/card_catalog/RECEIVE_THEME_MATCHED_CARD_SUITES',
  REQUEST_CARD_SUITE: 'zola/cards/card_catalog/REQUEST_CARD_SUITE',
  RECEIVE_CARD_SUITE: 'zola/cards/card_catalog/RECEIVE_CARD_SUITE',
  REQUEST_CARD: 'zola/cards/card_catalog/REQUEST_CARD',
  RECEIVE_CARD: 'zola/cards/card_catalog/RECEIVE_CARD',
  UPDATE_SEARCH_FILTERS: 'zola/cards/card_catalog/UPDATE_SEARCH_FILTER',
  RESET_SEARCH_FILTERS: 'zola/cards/card_catalog/RESET_SEARCH_FILTERS',
  SET_INITIAL_VARIATION_COLOR:
    'zola/cards/card_catalog/SET_INITIAL_VARIATION_COLOR',
  SET_RELATED_CARDS_FAMILY_NAME:
    'zola/cards/card_catalog/SET_RELATED_CARDS_FAMILY_NAME',
  RESET_RELATED_CARDS_FAMILY_NAME:
    'zola/cards/card_catalog/RESET_RELATED_CARDS_FAMILY_NAME',
  UPDATE_VARIATION_OPTIONS: 'zola/cards/card_catalog/UPDATE_VARIATION_OPTIONS',
  REQUEST_THEME_GROUPS_FOR_CARD:
    'zola/cards/card_catalog/REQUEST_THEME_GROUPS_FOR_CARD',
  RECEIVE_THEME_GROUPS_FOR_CARD:
    'zola/cards/card_catalog/RECEIVE_THEME_GROUPS_FOR_CARD',
  UPDATE_CATALOG_ADMIN_VIEW:
    'zola/cards/card_catalog/UPDATE_CATALOG_ADMIN_VIEW',
  SET_SELECTED_MEDIUM: 'zola/cards/card_catalog/SET_SELECTED_MEDIUM',
  REQUEST_RELATED_CARDS_FROM_SUITE:
    'zola/cards/card_catalog/REQUEST_RELATED_CARDS_FROM_SUITE',
  RECEIVE_RELATED_CARDS_FROM_SUITE:
    'zola/cards/card_catalog/RECEIVE_RELATED_CARDS_FROM_SUITE',
  RESET_RELATED_CARDS_FROM_SUITE:
    'zola/cards/card_catalog/RESET_RELATED_CARDS_FROM_SUITE',
  RECEIVE_COLLABORATORS: 'zola/cards/card_catalog/RECEIVE_COLLABORATORS',
  HYDRATE_MOTIFS: 'zola/cards/card_catalogs/HYDRATE_MOTIFS',
  UPDATE_SELECTED_MOTIFS: 'zola/cards/card_catalog/UPDATE_SELECTED_MOTIFS'
};

function requestSearchCardSuites() {
  return {
    type: ActionTypes.REQUEST_SEARCH_CARD_SUITES
  };
}

function receiveSearchCardSuites(json) {
  return {
    type: ActionTypes.RECEIVE_SEARCH_CARD_SUITES,
    payload: {
      cardSuites: json
    }
  };
}

function receiveThemeMatchedCardSuites(json) {
  return {
    type: ActionTypes.RECEIVE_THEME_MATCHED_CARD_SUITES,
    payload: {
      cardSuites: json
    }
  };
}

function requestCardSuite() {
  return {
    type: ActionTypes.REQUEST_CARD_SUITE
  };
}

function receiveCardSuite(json) {
  return {
    type: ActionTypes.RECEIVE_CARD_SUITE,
    payload: {
      cardSuite: json
    }
  };
}

function requestCard() {
  return {
    type: ActionTypes.REQUEST_CARD
  };
}

function receiveCard(json) {
  return {
    type: ActionTypes.RECEIVE_CARD,
    payload: {
      card: json
    }
  };
}

function requestThemeGroupsForCard() {
  return {
    type: ActionTypes.REQUEST_THEME_GROUPS_FOR_CARD
  };
}

function requestRelatedCardsFromSuite() {
  return {
    type: ActionTypes.REQUEST_RELATED_CARDS_FROM_SUITE
  };
}

function receiveThemeGroupsForCard(cardUUID, json) {
  return {
    type: ActionTypes.RECEIVE_THEME_GROUPS_FOR_CARD,
    payload: {
      cardUUID,
      themeGroups: json
    }
  };
}

function receiveRelatedCardsFromSuite(json) {
  return {
    type: ActionTypes.RECEIVE_RELATED_CARDS_FROM_SUITE,
    payload: {
      relatedCards: json
    }
  };
}

function receiveCollaborators(collaborators) {
  return {
    type: ActionTypes.RECEIVE_COLLABORATORS,
    payload: {
      collaborators
    }
  };
}

export function unMountRelatedCards() {
  return {
    type: ActionTypes.RESET_RELATED_CARDS_FROM_SUITE
  };
}

export function updateSearchFilters(key, value) {
  return {
    type: ActionTypes.UPDATE_SEARCH_FILTERS,
    payload: { key, value }
  };
}

export function resetSearchFilters() {
  return {
    type: ActionTypes.RESET_SEARCH_FILTERS
  };
}

export function resetRelatedCardsFamilyName() {
  return {
    type: ActionTypes.RESET_RELATED_CARDS_FAMILY_NAME
  };
}

export function setInitialVariationColor(color) {
  return {
    type: ActionTypes.SET_INITIAL_VARIATION_COLOR,
    payload: { color }
  };
}

export function setRelatedCardsFamilyName(familyName) {
  return {
    type: ActionTypes.SET_RELATED_CARDS_FAMILY_NAME,
    payload: { familyName }
  };
}

export function updateVariationOptions(variations) {
  return {
    type: ActionTypes.UPDATE_VARIATION_OPTIONS,
    payload: { variations }
  };
}

export function updateCatalogAdminView(isAdminView) {
  return {
    type: ActionTypes.UPDATE_CATALOG_ADMIN_VIEW,
    payload: { isAdminView }
  };
}

export function setSelectedMedium(selectedMedium) {
  return {
    type: ActionTypes.SET_SELECTED_MEDIUM,
    payload: { selectedMedium }
  };
}

export function hydrateMotifs(motif) {
  return {
    type: ActionTypes.HYDRATE_MOTIFS,
    payload: motif
  };
}

export function getMotifs() {
  return (dispatch) => {
    ApiService.get('/web-api/v1/card-catalog/motifs')
      .then((json) => {
        dispatch(hydrateMotifs(json));
      });
  };
}

export function updateSelectedMotifs(selected) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_SELECTED_MOTIFS,
      payload: selected
    });
  };
}


function realSearchCardSuites(updateLimitsAndSuch) {
  return (dispatch, getState) => {
    const { filters, initial } = getState().cards.cardCatalog;
    const requestBody = {
      offset: initial ? 0 : filters.offset + filters.limit,
      limit: filters.limit,
      active_only: filters.active_only,
      lead_card_type: filters.lead_card_type,
      color: filters.color,
      has_foil: filters.has_foil,
      has_custom_photo: filters.has_custom_photo,
      has_magnet: filters.has_magnet,
      collaborator: filters.collaborator,
      motifs: filters.motifs,
      has_digital: filters.has_digital
    };
    dispatch(requestSearchCardSuites());
    const functionToUse = updateLimitsAndSuch ? receiveSearchCardSuites : receiveThemeMatchedCardSuites;
    return ApiService.post('/web-api/v1/card-catalog/search', requestBody).then(
      json => dispatch(functionToUse(json))
    );
  };
}

export function searchCardSuites() {
  return realSearchCardSuites(true);
}

const body = state => ({
  active_only: true,
  lead_card_type: _get(state, 'cards.cardCatalog.filters.lead_card_type'),
  family: _get(state, 'wedding.themeGroupTitle'),
  offset: 0,
  limit: 10,
  color: null,
  has_foil: false,
  has_custom_photo: false,
  has_magnet: false,
  motifs: [],
  has_digital: false
});

export function initialLoadMatchingThemeCardsForUser() {
  return (dispatch, getState) => {
    const state = getState();

    return Just(state)
      .chain(get(['cards', 'cardCatalog', 'filters', 'collaborator']))
      .default(() => false)
      .chain(collab => (collab ? Nothing : Just(state))) // If any collab, then short circuit
      .chain(get(['user', 'hasIdentified']))
      .chain(hasIdentified => (hasIdentified ? Just() : Nothing)) // User must be authenticated
      .cata({
        Just: () => {
          dispatch(requestSearchCardSuites()); // Set busy state to true
          return dispatch(fetchWeddingTheme())
            .then(() => ApiService.post('/web-api/v1/card-catalog/search', body(getState()))) // use getState() instead of state here, to get updated themeGroupTitle
            .then(json => dispatch(receiveThemeMatchedCardSuites(json)));
        },
        Nothing: () => Promise.resolve()
      });
  };
}

export function getCollaborators() {
  return dispatch => (
    ApiService.get('/web-api/v1/card-catalog/collaborators')
      .then((json) => {
        dispatch(receiveCollaborators(json));
      })
  );
}

export function getCardSuite(suiteUUID, showUnlisted = false) {
  return (dispatch) => {
    dispatch(requestCardSuite());
    const requestBody = {
      show_unlisted: showUnlisted
    };
    return ApiService.post(
      `/web-api/v1/card-catalog/suites/${suiteUUID}`,
      requestBody
    ).then(json => dispatch(receiveCardSuite(json)));
  };
}

export function getMatchingStd(themeKey) {
  return () => {
    const requestBody = {
      theme_key: themeKey,
      card_type: 'SAVE_THE_DATE'
    };
    return ApiService.post(
      '/web-api/v1/card-catalog/matching-suites',
      requestBody
    ).then(response => response);
  };
}

// not currently used anywhere
export function getCard(cardUUID = 'db50de3b-521e-4f44-ad82-6b5136cfc04b') {
  return (dispatch) => {
    dispatch(requestCard());
    const requestBody = {
      show_unlisted: true
    };
    return ApiService.post(
      `/web-api/v1/card-catalog/cards/${cardUUID}`,
      requestBody
    ).then(json => dispatch(receiveCard(json)));
  };
}

export function getCardByVariationUUID(variationUUID, customizationUUID) {
  return (dispatch) => {
    dispatch(requestCard());
    const requestBody = {
      show_unlisted: true
    };
    return ApiService.post(
      `/web-api/v1/card-catalog/variations/${variationUUID}/card`,
      requestBody
    ).then((json) => {
      // TODO: think about possible ways to improve this without needing to inject customizationUUID
      // into response object, perhaps set cardUUID on customization objects in cardProject.customizations instead
      dispatch(receiveCard({ ...json, customizationUUID }));
      return { ...json, customizationUUID };
    });
  };
}

export function getThemeGroupsForCard(cardUUID) {
  return (dispatch) => {
    dispatch(requestThemeGroupsForCard());
    return ApiService.get(`/web-api/v1/card-catalog/cards/${cardUUID}/themes`)
      .then(json => dispatch(receiveThemeGroupsForCard(cardUUID, json)))
      .catch(() => console.log(`could not fetch theme groups for card ${cardUUID}`));
  };
}

export function getRelatedCardsFromSuite(familyName, color) {
  return (dispatch) => {
    const requestBody = {
      offset: 0,
      limit: 50, // TODO: limit int seems to be mandatory. In that context, we don't need it.
      active_only: true,
      lead_card_type: null,
      color,
      has_foil: null,
      has_custom_photo: null,
      has_magnet: null,
      family: familyName
    };
    dispatch(requestRelatedCardsFromSuite());
    return ApiService.post('/web-api/v1/card-catalog/search', requestBody).then(
      json => dispatch(receiveRelatedCardsFromSuite(json))
    );
  };
}



// WEBPACK FOOTER //
// ./src/cards/actions/cardCatalogActions.js